import { useCallback, useMemo, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { BoutiqueCalendarDateFormat, BoutiqueCalendarWeekStep } from '../boutique-calendar.constants';
import { buildBoutiqueWeekDayList, formatBoutiqueWeekRange, getBoutiqueWeekStartDate } from '../boutique-calendar.utils';

export function useBoutiqueCalendarWeek(now: Dayjs = dayjs()) {
	const [weekStartDate, setWeekStartDate] = useState<Dayjs>(() => getBoutiqueWeekStartDate());

	const todayKey = now.format(BoutiqueCalendarDateFormat.key);
	const dayList = useMemo(() => buildBoutiqueWeekDayList(weekStartDate, todayKey), [weekStartDate, todayKey]);
	const rangeLabel = useMemo(() => formatBoutiqueWeekRange(weekStartDate), [weekStartDate]);

	const onPreviousWeek = useCallback(() => setWeekStartDate(currentDate => currentDate.subtract(BoutiqueCalendarWeekStep, 'week')), []);
	const onNextWeek = useCallback(() => setWeekStartDate(currentDate => currentDate.add(BoutiqueCalendarWeekStep, 'week')), []);
	const onCurrentWeek = useCallback(() => setWeekStartDate(getBoutiqueWeekStartDate()), []);

	return { weekStartDate, dayList, rangeLabel, onPreviousWeek, onNextWeek, onCurrentWeek };
}
